import { Trans, useLingui } from '@lingui/react/macro';

import FileUpload from '@/components/FileUpload';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

const ProofOfPurchase = () => {
  const { t } = useLingui();

  const { article, view, errors, proofOfPurchaseMedia } = useArticleContext();

  return (
    <FileUpload
      uploadData={{
        type: 'proof-of-purchase',
        articleId: article.id,
      }}
      ariaLabel={t({
        id: 'article.form.proof-of-purchase.aria-label',
        message: 'Upload proof of purchase',
      })}
      type="file"
      label={
        <>
          <Trans id="article.form.proof-of-purchase.label">Proof of purchase</Trans>
          {!view.warranty.fields.proofOfPurchase.required &&
            !view.warranty.fields.proofOfPurchaseOrOrderNumber.required && <OptionalLabel />}
        </>
      }
      media={proofOfPurchaseMedia}
      error={
        errors.warranty?.missingProofOfPurchase
          ? t({
              id: 'article.form.proof-of-purchase.error',
              message: 'A proof of purchase is required',
            })
          : errors.warranty?.missingProofOfPurchaseOrOrderNumber
            ? t({
                id: 'article.form.proof-of-purchase-or-order-number.error.missing',
                message: 'A proof of purchase or an order number is required',
              })
            : undefined
      }
      deleteWithApi
      size="large"
      withQrCode
    />
  );
};

export default ProofOfPurchase;
